export const UPDATE_TAB_NAME =
  'client/modules/markets/actions/current-tab/UPDATE_TAB_NAME';

export function updateTabName(tabName) {
  return {
    type: UPDATE_TAB_NAME,
    tabName,
  };
}
